/* tslint:disable */
/* eslint-disable */
/**
 * Hyper-Timesheet.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LavoriDettaglioResponseDTO
 */
export interface LavoriDettaglioResponseDTO {
    /**
     * 
     * @type {number}
     * @memberof LavoriDettaglioResponseDTO
     */
    oreLavorate?: number;
    /**
     * 
     * @type {number}
     * @memberof LavoriDettaglioResponseDTO
     */
    oreViaggio?: number | null;
    /**
     * 
     * @type {number}
     * @memberof LavoriDettaglioResponseDTO
     */
    oreViaggioExtra?: number | null;
    /**
     * 
     * @type {string}
     * @memberof LavoriDettaglioResponseDTO
     */
    nota?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LavoriDettaglioResponseDTO
     */
    localita?: string | null;
    /**
     * 
     * @type {number}
     * @memberof LavoriDettaglioResponseDTO
     */
    idMezzo?: number | null;
    /**
     * 
     * @type {number}
     * @memberof LavoriDettaglioResponseDTO
     */
    idTipoIntervento?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof LavoriDettaglioResponseDTO
     */
    smartWorking?: boolean;
    /**
     * 
     * @type {number}
     * @memberof LavoriDettaglioResponseDTO
     */
    idWBSRamo?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof LavoriDettaglioResponseDTO
     */
    allowEdit?: boolean;
    /**
     * 
     * @type {number}
     * @memberof LavoriDettaglioResponseDTO
     */
    idPersonale?: number;
    /**
     * 
     * @type {Date}
     * @memberof LavoriDettaglioResponseDTO
     */
    date?: Date;
    /**
     * 
     * @type {number}
     * @memberof LavoriDettaglioResponseDTO
     */
    idCommessa?: number;
}

/**
 * Check if a given object implements the LavoriDettaglioResponseDTO interface.
 */
export function instanceOfLavoriDettaglioResponseDTO(value: object): value is LavoriDettaglioResponseDTO {
    return true;
}

export function LavoriDettaglioResponseDTOFromJSON(json: any): LavoriDettaglioResponseDTO {
    return LavoriDettaglioResponseDTOFromJSONTyped(json, false);
}

export function LavoriDettaglioResponseDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): LavoriDettaglioResponseDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'oreLavorate': json['oreLavorate'] == null ? undefined : json['oreLavorate'],
        'oreViaggio': json['oreViaggio'] == null ? undefined : json['oreViaggio'],
        'oreViaggioExtra': json['oreViaggioExtra'] == null ? undefined : json['oreViaggioExtra'],
        'nota': json['nota'] == null ? undefined : json['nota'],
        'localita': json['localita'] == null ? undefined : json['localita'],
        'idMezzo': json['idMezzo'] == null ? undefined : json['idMezzo'],
        'idTipoIntervento': json['idTipoIntervento'] == null ? undefined : json['idTipoIntervento'],
        'smartWorking': json['smartWorking'] == null ? undefined : json['smartWorking'],
        'idWBSRamo': json['idWBSRamo'] == null ? undefined : json['idWBSRamo'],
        'allowEdit': json['allowEdit'] == null ? undefined : json['allowEdit'],
        'idPersonale': json['idPersonale'] == null ? undefined : json['idPersonale'],
        'date': json['date'] == null ? undefined : (new Date(json['date'])),
        'idCommessa': json['idCommessa'] == null ? undefined : json['idCommessa'],
    };
}

export function LavoriDettaglioResponseDTOToJSON(json: any): LavoriDettaglioResponseDTO {
    return LavoriDettaglioResponseDTOToJSONTyped(json, false);
}

export function LavoriDettaglioResponseDTOToJSONTyped(value?: LavoriDettaglioResponseDTO | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'oreLavorate': value['oreLavorate'],
        'oreViaggio': value['oreViaggio'],
        'oreViaggioExtra': value['oreViaggioExtra'],
        'nota': value['nota'],
        'localita': value['localita'],
        'idMezzo': value['idMezzo'],
        'idTipoIntervento': value['idTipoIntervento'],
        'smartWorking': value['smartWorking'],
        'idWBSRamo': value['idWBSRamo'],
        'allowEdit': value['allowEdit'],
        'idPersonale': value['idPersonale'],
        'date': value['date'] == null ? undefined : ((value['date']).toISOString()),
        'idCommessa': value['idCommessa'],
    };
}

